<template>
    <div class="social">
        <div class="social-title">{{ $t("register.orUsing") }}:</div>
        <ul class="social-list">
            <li v-for="link in social" :key="link.key" class="social-item">
                <a :href="'/social/login/' + link.link + '/'" :class="['social-link', 'social-' + link.key]"></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Social",
    props: {
        i18n: Object,
    },
    data() {
        return {
            social: [
                // {key: 'apple', link: 'apple-id'},
                // { key: "google", link: "google-oauth2" },
                // {key: 'facebook', link: 'facebook'},
                { key: "yandex", link: "yaru" },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_social";
</style>
